import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  altSection: {
    [theme.breakpoints.up('lg')]: {
      width: 380,
      margin: '0 auto'
    }
  }
}))
